import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { BariPostEnrollmentData } from './types';

type BariPostEnrollmentReadKey = keyof BariPostEnrollmentData;

export type BariPostEnrollmentLabwaardenReadLabel =
    | 'Bijzonderheden labwaarden'
    | 'Datum lab geprikt'
    | 'Pre-operatieve labwaarden';

export type BariPostEnrollmentOperatieReadLabel =
    | 'Bijzonderheden'
    | 'Complicaties'
    | 'Datum operatie'
    | 'Gewicht voor operatie'
    | 'Ingreep'
    | 'Naam chirurg'
    | 'Omschrijving bijzonderheden'
    | 'Omschrijving complicaties'
    | 'Toelichting ingreep'
    | 'Type complicaties';

export type BariPostEnrollmentReadSectionTitle = 'Labwaarden' | 'Operatie';

export const operatieReadSection: TypedReadSchema<
    BariPostEnrollmentReadKey,
    BariPostEnrollmentOperatieReadLabel,
    'Operatie'
> = {
    items: [
        {
            key: 'datum_operatie',
            label: 'Datum operatie',
            type: 'dateAsString',
        },
        {
            key: 'naam_chirurg',
            label: 'Naam chirurg',
        },
        {
            append: 'kg',
            key: 'gewicht_voor_operatie',
            label: 'Gewicht voor operatie',
            type: 'number',
        },
        {
            key: 'ingreep',
            label: 'Ingreep',
        },
        {
            key: 'complicaties',
            label: 'Complicaties',
            type: 'boolean',
        },
        {
            key: 'complicatie_type',
            label: 'Type complicaties',
        },
        {
            key: 'complicaties_omschrijving',
            label: 'Omschrijving complicaties',
        },
        {
            key: 'bijzonderheden',
            label: 'Bijzonderheden',
            type: 'boolean',
        },
        {
            key: 'bijzonderheden_omschrijving',
            label: 'Omschrijving bijzonderheden',
        },
    ],
    sectionTitle: 'Operatie',
};
